<template>
    <transition-group
        mode="out-in"
        name="lb-project-list"
        tag="div"
        class="columns is-multiline is-mobile mx-0"
        appear
    >
        <div
            v-for="i in items"
            :key="i"
            class="column is-12-mobile is-6-tablet is-4-widescreen"
        >
            <div class="lb-project-box is-loading"></div>
        </div>
    </transition-group>
</template>

<script>
export default {
    props: {
        items: {
            type: Number,
            default: 6,
        },
    },
};
</script>

<style></style>
